import { createApp } from "vue"
import { createPinia } from "pinia"
import piniaPersistedState from "pinia-plugin-persistedstate"
import { Quasar } from "quasar"
import axios from "axios"

import App from "./App.vue"
import router from "./router.js"
import quasarUserOptions from "./quasarUserOptions.js"
import { useSessionStore } from "./stores/userSession.js"

import "ol/ol.css"
import "./global.scss"

const pinia = createPinia()
pinia.use(piniaPersistedState)

const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(Quasar, quasarUserOptions)

if (!import.meta.env.DEV) {
  axios.defaults.baseURL = import.meta.env.VITE_APP_API_URL || ""
}

axios.interceptors.request.use((config) => {
  const sessionStore = useSessionStore()
  if (sessionStore.session?.token) {
    config.headers.Authorization = `Bearer ${sessionStore.session.token}`
  }
  return config
})

app.mount("#app")
